import BaseTracker from './tk.base.tracker';
import { TrackBasket, TrackerOptions, TrackFavorite, TrackItem } from './tk.tracker';

export default class TKGoogleTracke extends BaseTracker {
    constructor(trackingId: string, options?: TrackerOptions) {
        super(trackingId, window.dataLayer || [], `https://www.googletagmanager.com/gtm.js?id=%KEY`, options);

        this.basketEventMap = options?.basketEventMap || {
            added: 'add_to_cart',
            deleted: 'remove_from_cart',
            changed: 'update_cart',
        };

        this.favoriteEventMap = options?.favoriteEventMap || {
            added: 'add_from_wishlist',
            deleted: 'remove_from_wishlist',
        };
    }

    init(): Promise<void> {
        return new Promise((resolve, reject) => {
            try {
                this.initGTM();
                this.loadScript()
                    .then(() => {
                        console.log('Google Tag Manager successfully loaded');
                        resolve();
                    })
                    .catch((error) => {
                        console.error('Error loading Google Tag Manager', error);
                        reject(error);
                    });
            } catch (error) {
                console.error('Google Tag Manager initialization failed', error);
                reject(error);
            }
        });
    }

    initGTM() {
        this.tracker.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    }

    push(item: TrackItem) {
        const { event, ...rest } = item;

        this.tracker.push({
            event: event,
            ecommerce: { ...rest },
        });
    }

    pushBasket(item: TrackBasket) {
        this.tracker.push({
            event: this.basketEventMap[item.event as keyof typeof this.basketEventMap],
            ecommerce: {
                currencyCode: item.currency,
                value: item.value,
                items: item.items.map((item) => ({
                    item_id: item.sku,
                    item_name: item.name,
                    price: item.price,
                    quantity: item.quantity,
                })),
            },
        });
    }

    pushFavorite(item: TrackFavorite) {
        this.tracker.push({
            event: this.favoriteEventMap[item.action as keyof typeof this.favoriteEventMap],
            ecommerce: {
                category: item.category,
                action: this.favoriteActionMap[item.action as keyof typeof this.favoriteActionMap],
                name: item.name,
                value: item.value,
            },
        });
    }
}
